

export default {
  name: 'WhatsappBtn',

  data() {
    return {};
  },
  props: {},
  computed: {
    vars() {
      return this.$store.state?.appState?.vars || {};
    },
    whatsapp() {
      return this.vars.whatsapp || '';
    },
  },
};
